import React, { FC } from 'react'

import { Link } from 'mf-ui-components'

import { l10nCopy } from '../../../../utils/copy/l10nCopy'

import {
  Container,
  Image,
  TextContainer,
  Title,
  TitleContainer,
} from './BlogPost.styles'
import { BlogPost as BlogPostType } from './types'

type Props = BlogPostType

export const BlogPost: FC<Props> = ({
  title,
  description,
  imageURL,
  postURL,
}) => (
  <Container>
    <TitleContainer>
      <Title>{title}</Title>
    </TitleContainer>
    <Image src={imageURL} aria-hidden />
    <TextContainer>
      {description}
      <Link href={postURL} role="primary" style={{ marginLeft: '1rem' }}>
        {l10nCopy('blogEntries.readMore')}
      </Link>
    </TextContainer>
  </Container>
)
